// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useDifusiones } from "../context/DifusionesContext";
import { useBody } from '../../Body/state/BodyContext';
import { useAreas } from '../../Areas/State/AreasContext';
import ItemListaEmails from "../ItemListaEmails";
import SelectListasCompartidas from './nueva-lista/SelectListasCompartidas';
import { ModalGeneral } from '../../Componentes/ModalGeneral';
import {
    Box,
    Typography,
    Divider,
    CircularProgress,
    Alert,
    Chip,
    Button,
    TextField,
} from '@mui/material';
import { Save } from '@mui/icons-material';

export const ModificarListaModal = ({ open, onClose, listaSeleccionada, onSuccess }) => {
    const { listas, editarLista, areasUser } = useDifusiones();
    const { setMessage, setSuccess } = useBody();
    const { getAreas, getArea } = useAreas();
    const [areasCompartidas, setAreasCompartidas] = useState([]);
    const [emails, setEmails] = useState([]);
    const [nombre, setNombre] = useState('');
    const [loading, setLoading] = useState(false);
    const [rootAreas, setRootAreas] = useState([]);
    const [loadingRootAreas, setLoadingRootAreas] = useState(false);
    const [nombreArea, setNombreArea] = useState(null);

    useEffect(() => {
        if (listaSeleccionada) {
            setAreasCompartidas(listaSeleccionada.compartidos || []);
            setEmails(listaSeleccionada.integrantes || []);
            setNombre(listaSeleccionada.nombre || '');
        }
    }, [listaSeleccionada]);

    useEffect(() => {
        if (!open || !listaSeleccionada?.propietario) return;
        const areaLocal = areasUser.find(a => a.id === listaSeleccionada.propietario);
        if (areaLocal) setNombreArea(areaLocal.name);
        else setNombreArea(null);
        setLoadingRootAreas(true);
        const fetchArea = areaLocal ? Promise.resolve(null) : getArea(listaSeleccionada.propietario);
        Promise.all([getAreas(), fetchArea]).then(([areas, area]) => {
            setRootAreas(areas ?? []);
            if (area) setNombreArea(area.name ?? '');
        }).finally(() => setLoadingRootAreas(false));
    }, [open]);

    const handleAreasCompartidasChange = (nuevasAreasCompartidas) => {
        setAreasCompartidas(nuevasAreasCompartidas);
    };

    const handleEmailsChange = (nuevosEmails) => {
        setEmails(nuevosEmails);
    };

    const onSubmit = async () => {
        if (!/\S/.test(nombre)) {
            setMessage('La lista debe poseer un nombre');
            return;
        }

        const duplicada = listas
            .filter(lista => lista.propietario === listaSeleccionada.propietario)
            .some(lista => lista.nombre === nombre && lista.id !== listaSeleccionada.id);

        if (duplicada) {
            setMessage('Ya existe una lista con ese nombre en esta área');
            return;
        }

        if (emails.length === 0) {
            setMessage('La lista debe tener al menos un destinatario');
            return;
        }

        setLoading(true);
        try {
            await editarLista(listaSeleccionada.id, {
                nombre,
                integrantes: emails,
                compartidos: areasCompartidas?.map(area => area.id) || [],
            });
            setSuccess("Lista modificada exitosamente");
            onSuccess({ id: listaSeleccionada.id, nombre, integrantes: emails, compartidos: areasCompartidas });
            onClose();
        } catch (error) {
            console.error("Error al modificar la lista:", error);
            setMessage("Error al modificar la lista");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalGeneral
            open={open}
            onClose={onClose}
            titulo="Modificar Lista"
            Contenido={
                <Box component="form" mt={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
                        <TextField
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            label="Nombre de la lista"
                            variant="standard"
                            inputProps={{ style: { fontSize: '1.25rem', fontWeight: 500 } }}
                            sx={{ width: 260 }}
                        />
                        <Chip
                            label={nombreArea === null
                                ? <CircularProgress size={12} color="inherit" />
                                : nombreArea || "Área no encontrada"
                            }
                            color="primary"
                            sx={{ mt: 1.5, flexShrink: 0 }}
                        />
                    </Box>

                    <Box sx={{ my: 5 }}>
                        <Divider sx={{ my: 2 }}>
                            <Typography variant="caption" color="text.secondary">Compartir con Áreas</Typography>
                        </Divider>
                        <SelectListasCompartidas
                            areaSeleccionada={listaSeleccionada.propietario}
                            areasCompartidas={areasCompartidas}
                            handleAreasCompartidasChange={handleAreasCompartidasChange}
                            rootAreas={rootAreas}
                            loadingRootAreas={loadingRootAreas}
                        />
                        <Alert severity="info" sx={{ mt: 2 }}>
                            Puede seleccionar las áreas a las cuales desea compartirles esta lista.
                        </Alert>
                    </Box>

                    <Divider sx={{ my: 2 }}>
                        <Typography variant="caption" color="text.secondary">Destinatarios</Typography>
                    </Divider>

                    <ItemListaEmails
                        handleEmailsChange={handleEmailsChange}
                        emails={emails}
                        isModificar={true}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
                        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant="contained"
                            color="primary"
                            startIcon={loading ? null : <Save />}
                            disabled={loading}
                            onClick={onSubmit}
                            type="button"
                        >
                            {loading ? 'Guardando...' : 'Guardar'}
                        </Button>
                    </Box>
                </Box>
            }
        />
    );
};
